/** 静态变量 **/
// todo 整改上线后换成这个
// export const CDN = process.env.VUE_APP_OSS_CDN;
// 咨询客户地址
export const CUSTOMER_SERVICE_URL = "//tb.53kf.com/code/client/5a775839122ba67b45875dc424ee54637/2";
export const CDN = "//file-smallv.qianlima.com";
// wap 端首页
export const WAP_INDEX = "//wap.qianlima.com";
// PC 端首页
export const PC_INDEX = "//www.qianlima.com";

// wap 登录页面
export const WAP_LOGIN_URL = "//wap.qianlima.com/login.jsp";
